import axios, { AxiosRequestConfig } from 'axios';

const getPermissionToken = async (
  apiEndpoint: string,
  authToken: string,
  elevated = false,
  selectedInstitutionId?: string | null,
) => {
  const PERMISSION_URL = `https://${apiEndpoint}/permissions-proxy/permissions/token${
    elevated ? `?elevated=true` : ''
  }`;

  const headers: Record<string, unknown> = {
    authorization: `Bearer ${authToken}`,
  };

  if (selectedInstitutionId) {
    headers['x-datapoints-institution'] = selectedInstitutionId;
  }

  try {
    const response = await axios.get(PERMISSION_URL, {
      headers: headers as AxiosRequestConfig['headers'],
    });

    return response.data.token;
  } catch (e) {
    if (e instanceof Error) {
      // eslint-disable-next-line no-console
      console.log(`Failed to load permission token: ${e.message}`);
    } else {
      // eslint-disable-next-line no-console
      console.log(`Unknown Error: ${e}`);
    }
    return null;
  }
};

export default getPermissionToken;
